import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { DsProjectService, DsProject } from '@sixense/ds-roazhon-service';
/** Sixense */
import { BydModel } from '@sixense/byd-core-service';

@Injectable({ providedIn: 'root' })
export class ProjectListResolver implements Resolve<BydModel<DsProject>> {
  /**
   * Creates an instance of ProjectListResolver.
   *
   * @param projectService the projects service
   */
  constructor(private projectService: DsProjectService) {}

  /**
   * The project list resolve.
   *
   * @returns Observable<BydModel<DsProject>>
   */
  resolve(): Observable<BydModel<DsProject>> {
    return this.projectService.getProjects();
  }
}
